@if(candidatesApplied.length) {
<div class="d-flex flex-column" style="padding: 15px">
  <div *ngIf="candidatesAccepted.length">
    <div class="py-px-24">
      <app-text-separator text="Acceptée"></app-text-separator>
    </div>

    @for (item of candidatesAccepted; track $index) {
    <div class="card-container p-px-16 mb-px-24">
      <div class="w-fit-content pb-px-16">
        <app-tag [label]="candidatStatusLabelsMap[item.statusOfCandidatOnMission] || item.statusOfCandidatOnMission" [type]="1" customIcon="check-success"></app-tag>
      </div>
      <div class="d-flex justify-content-between align-items-center">
        <div class="d-flex flex-column">
          <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>
          <!--                <div class="d-flex align-items-center mt-px-16">-->
          <!--                  <span class="text-secondary fs-11 fw-4">il y a 35 minutes</span>-->
          <!--                  <span class="text-secondary fs-11 fw-4 mx-1">|</span>-->
          <!--                  <span class="text-secondary fs-11 fw-4">13 Anciennes collaborations</span>-->
          <!--                </div>-->
        </div>
        <div class="d-flex align-items-center">
          <app-button text="Voir profil" [stroked]="true" color="primary" class="me-1"
                      (handleClick)="openDetailCandidate(item.candidatId)" ></app-button>
<!--          <app-button text="Voir le contrat" [stroked]="true"-->
<!--            (handleClick)="updateApplicationStatus(item, CandidatStatusOnMission.CANDIDAT_APPLIED_ON_THIS_MISSION)"></app-button>-->
        </div>
      </div>
    </div>
    }
  </div>

  @if(true) {

    <div class="py-px-24" *ngIf="candidatesNotAccepted.length">

      <app-text-separator text="Toutes les candidatures" textClass="w-px-300"></app-text-separator>
    </div>

    @for (item of candidatesNotAccepted; track $index) {
      <div class="card-container p-px-16 mb-px-24">
        <div class="d-flex justify-content-between align-items-center">
          <div class="d-flex flex-column">
            <app-user [text]="item.candidateName" [imageSrc]="item.candidatePhoto"></app-user>

          </div>
          <div class="d-flex align-items-center">
            <app-button text="Voir profil" [stroked]="true" color="primary" class="me-1"
                        (handleClick)="openDetailCandidate(item.candidatId)"></app-button>
            @if(item.statusOfCandidatOnMission == CandidatStatusOnMission.CANCELLATION_REQUEST_AFTER_SIGN_CONTRACT) {
              <app-button text="Accepter la demande d'annulation" [disabled]="candidatesAccepted.length > 0 || loading" [loading]="loading"
                          (handleClick)="acceptCancelRequest(item)" srcIcon="/assets/icons/double-checks-white.svg"></app-button>
            } @else {
              <app-button text="Accepter" [disabled]="expired || candidatesAccepted.length > 0 || loading" [loading]="loading"
                          (handleClick)="updateApplicationStatus(item)" srcIcon="/assets/icons/double-checks-white.svg"></app-button>
            }
          </div>
        </div>
      </div>
    }
  }





</div>

}
@else{
<div class="d-flex flex-column no-condidat" style="padding: 15px">
  <svg-icon src="/assets/icons/search-file.svg"></svg-icon>
  <div class="d-flex flex-column">
    <span class="fs-20 fw-4">Aucun candidat pour l'instant</span>
    <span class="text-secondary fs-16 fw-4">Les candidatures pour cette mission seront affichées ici. Vous pourrez
      sélectionner et accepter un candidat parmi la liste.</span>
  </div>
</div>

}
